// @ts-check
// src/stores/settings.js — Sesja 3.6 — Settings/Users/Couriers state in Nanostores

import { atom } from 'nanostores';

/** Ustawienia firmy (companySettings) */
export const $companySettings = atom(/** @type {any} */ (null));

/** Lista kont wysyłki / przewoźników */
export const $shippingAccounts = atom(/** @type {any[]} */ ([]));

/** Wybrane konto InPost (couriers tab) */
export const $couriersInPostAccountId = atom(/** @type {any} */ (null));

/** Status integracji InPost */
export const $couriersInPostStatus = atom(/** @type {any} */ (null));

/** Lista użytkowników */
export const $usersList = atom(/** @type {any[]} */ ([]));

/** Lista ról */
export const $rolesList = atom(/** @type {any[]} */ ([]));

if (typeof window !== 'undefined') {
  /** @type {any} */ (window).__sbStores = Object.assign(/** @type {any} */ (window).__sbStores || {}, {
    $companySettings,
    $shippingAccounts,
    $couriersInPostAccountId,
    $couriersInPostStatus,
    $usersList,
    $rolesList,
  });
}
